<template>
  <div class="site_nav">
    <div class="main_page">
      <a class="site_nav_tell" href="javascript:;">
        服务热线： 010-68710020
      </a>
      <a class="site_nav_email" href="javascript:;">
        服务邮箱：service@ewisest.com
      </a>
      <ul class="site_nav_menu">
        <li id="userName"><a href="javascript:;">欢迎：{{info}}</a></li>
        <li class="cur" id="login"><a href="login.html">登录</a></li>
        <li id="register"><a href="register.html">免费注册</a></li>
        <li id="myCenter"><a href="personalCenter.html">我的中心</a></li>
        <li id="myConsultantCenter" style="display:none;"><a href="Consultant_center.html">顾问中心</a></li>
        <li id="myCompanyCenter" style="display:none;"><a href="Ent_center.html">企业中心</a></li>
        <li class="no_border"><a href="service_law.html" >帮助与支持</a></li>
        <li class="no_border" id="logout" style="display:none;"><a href="javascript:;" @click="isLogout">退出</a></li>
        <li class="no_border site_nav_menu_map"><a href="javascript:;">导航</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery';
  export  default{
    data: function () {
      return {
        info:""
      };
    },
    ready:function() {
      var self = this;
      var str = window.location;
      if(str.pathname=="/Consultant_center.html"||str.pathname=="/Consultant_show.html"||str.pathname=="/Consultant_detail.html"){
        $("#myConsultantCenter").attr("class","cur");
      }else if(str.pathname=="/personalCenter.html"){
        $("#myCenter").attr("class","cur");
      }else if(str.pathname=="/Ent_center.html"){
         $("#myCompanyCenter").attr("class","cur");
      }
      util.sendAjax({
        type:"POST",
        url:"loginStatus",
        data:{},
        success:function(json) {
          console.log(json);
          if (json.success == true) {
            if (json.data == "true") {
              //查询基本信息
              util.sendAjax({
                type: 'POST',
                url: 'mem/queryOwnMemInfo',
                data: {},
                success: function (json) {
                  console.log(json);
                  if (json.success == true) {

                    $("#userName").show();
                    $("#login").hide();
                    $("#register").hide();
                    $("#myCenter").show();
                    $("#logout").show();
                    self._data.info = json.data.mobilePhone;
                  } else {
                    $("#userName").hide();
                    $("#login").show();
                    $("#register").show();
                    $("#myCenter").hide();
                    $("#logout").hide();
                  }
                }
              });
              //查询角色信息
              var myRole = userInfo.getRole();
              console.log(myRole);
              if (util.isVal(myRole) != "") {
                if (myRole.memRole == "true") {
                  $("#myCenter").show();
                }
                if (myRole.entRole == "true") {
                  $("#myCompanyCenter").show();
                }
                if (myRole.resRole == "true") {
                  $("#myConsultantCenter").show();
                }
              } else {
                if (str.pathname == "/" || str.pathname == "index.html") {
                  layer.msg("您还没有登录!");
                } else {
//                window.location.href="login.html";
                }
              }
            }
          }
        }
      })
    },
    methods:{
      isLogout:function(){
        util.sendAjax({
          type:"POST",
          url:"logout",
          data:{},
          success:function(data){
            if(data.success==true){
              window.location.href="index.html";
            }
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Head.vue?0b3e6faa